'use strict'

import HttpClient from '@/app/service/api/http/http-client'

export default {
  install (Vue, httpUrl, wsUrl, store, router = null) {
    const httpClient = new HttpClient(httpUrl)
    httpClient.addDefaultInterceptors()
    Vue.prototype.$http = httpClient.instance
  }
}
